import { render, staticRenderFns } from "./pull-refresh.vue?vue&type=template&id=8fca7454&scoped=true&"
import script from "./pull-refresh.vue?vue&type=script&lang=js&"
export * from "./pull-refresh.vue?vue&type=script&lang=js&"
import style0 from "./pull-refresh.vue?vue&type=style&index=0&id=8fca7454&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fca7454",
  null
  
)

export default component.exports